import { createRoot } from 'react-dom/client'

// third party
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'

// msal
import { PublicClientApplication, EventType } from '@azure/msal-browser'

// project imports
import { msalConfig } from './authConfig.js'
import { setAccessToken } from 'utils/accessToken'
import * as serviceWorker from 'serviceWorker'
import App from 'App'
import { store } from 'store'

// i18n must initialize before the app renders
import './i18n'

// style + assets
import 'assets/scss/style.scss'
import 'react-toastify/dist/ReactToastify.css'

import { Buffer } from 'buffer'
window.Buffer = Buffer

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(msalConfig)

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account)
    setAccessToken(event.payload.idToken)
  }
})

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root')
const root = createRoot(container) // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <App instance={msalInstance} />
    <ToastContainer autoClose={5000} hideProgressBar theme="colored" />
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
